export default {
  avatarImage: require('@/assets/images/avatars/melissa-avatar.png'),
  avatarInitials: 'MB',
  lang: 'en-CA',
  gender: 'Female',
  voice: 'Microsoft Server Speech Text to Speech Voice (en-CA, ClaraNeural)'
}
